import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxPermissionsModule, NgxPermissionsService} from 'ngx-permissions';
import {NgHttpLoaderModule} from 'ng-http-loader';
import {AuthService} from './services/auth.service';
import {NgxIndexedDBModule} from 'ngx-indexed-db';
import {INDEX_DB_CONFIGURATION} from './shared/constants/data.const';
import {GraphQLModule} from './graphql.module';
import {HTTP_INTERCEPTORS, HttpBackend, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SharedModule} from './shared/shared.module';
import {DatePipe} from '@angular/common';
import {HttpRequestInterceptor} from './shared/interceptors/http-request.interceptor';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {ToastContainerComponent} from './shared/components/toast-container/toast-container.component';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

// Uses HttpBackend (not HttpClient) deliberately — going through the app's
// intercepted HttpClient here creates a real circular dependency, since
// HttpRequestInterceptor (one of our HTTP_INTERCEPTORS) depends on
// AuthService, which itself injects HttpClient directly. HttpBackend
// bypasses the interceptor chain entirely, sidestepping the cycle — and translation
// files shouldn't get auth headers or trigger the app's error interceptor anyway.
export function httpTranslateLoaderFactory(httpBackend: HttpBackend): TranslateLoader {
  return new TranslateHttpLoader(new HttpClient(httpBackend), '/assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    NgHttpLoaderModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoaderFactory,
        deps: [HttpBackend],
      },
    }),
    SharedModule,
    BrowserAnimationsModule,
    NgxIndexedDBModule.forRoot(INDEX_DB_CONFIGURATION),

    GraphQLModule,
    HttpClientModule,
    ToastContainerComponent,
  ],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    {
      provide: MAT_DATE_LOCALE, useValue: 'en-GB'
    },
    NgxPermissionsService, {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => {
        return (
          async () => {
            await auth.authRole();
          }
        );
      },
      deps: [AuthService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
